import { Link } from "react-router-dom";
import { Instagram, Mail, MessageSquare } from "lucide-react";
import { EMAIL, INSTAGRAM_URL, INSTAGRAM_HANDLE, SMS_URL, PHONE_DISPLAY, PHONE_TEL } from "@/config";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-sand text-charcoal">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 md:grid-cols-3 md:px-12">
        <div>
          <img
            src="/logo.png"
            alt="Logo Juliette Maquestiau"
            data-testid="footer-logo"
            className="h-16 w-16 rounded-full object-cover ring-1 ring-taupe/60"
          />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-stone-600">
            Juliette Maquestiau — Thérapeute comportementale pour les jeunes de 10 à 20 ans.
            Expliquer sans stigmatiser, normaliser sans banaliser, outiller sans culpabiliser.
          </p>
        </div>

        <div>
          <p className="font-display text-xs tracking-[0.2em] uppercase text-stone-500">Navigation</p>
          <div className="mt-5 flex flex-col gap-3">
            {[
              { to: "/", label: "Accueil" },
              { to: "/accompagnement", label: "Accompagnement" },
              { to: "/a-propos", label: "À propos" },
              { to: "/lieux", label: "Lieux" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
                className="text-sm text-stone-700 transition-colors hover:text-taupe"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="font-display text-xs tracking-[0.2em] uppercase text-stone-500">Restons en lien</p>
          <div className="mt-5 flex flex-col gap-4">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 text-sm text-stone-700 transition-colors hover:text-taupe"
            >
              <Instagram size={16} /> {INSTAGRAM_HANDLE}
            </a>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email-link"
              className="inline-flex items-center gap-2 text-sm text-stone-700 transition-colors hover:text-taupe"
            >
              <Mail size={16} /> {EMAIL}
            </a>
            <a
              href={`sms:${PHONE_TEL}`}
              data-testid="footer-sms-link"
              className="inline-flex items-center gap-2 text-sm text-stone-700 transition-colors hover:text-taupe"
            >
              <MessageSquare size={16} /> {PHONE_DISPLAY} (SMS uniquement)
            </a>
            <a
              href={SMS_URL}
              data-testid="footer-agenda-button"
              className="mt-2 inline-flex w-fit items-center gap-2 rounded-full bg-taupe px-5 py-2.5 font-display text-sm text-bone transition-colors hover:bg-taupe-dark"
            >
              <MessageSquare size={16} /> Prendre rendez-vous par SMS
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-stone-200 py-6 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} Juliette Maquestiau — Tous droits réservés
      </div>
    </footer>
  );
}
